import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';

// components
import { Card, CardBody, Row, Col, Container, FormGroup, Form, Input, Button, Spinner } from "reactstrap";
import Select from 'react-select';

// style
import "assets/css/loading.css";

// helpers
import { showMessage } from "../../helpers/message.js";
import { removeAllCookies, getSessionCookie, setSessionCookie } from "../../helpers/cookies.js";

// api
import usuario_api from "../../api/usuario_api.js";
import local_api from "../../api/local_api.js";

//Context
import { useAuth } from "../../context/auth.js";

export default function Login({ history }) {
    const { signIn } = useAuth();

    const { register, handleSubmit, setValue, clearErrors, errors } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = React.useState(false);

    useEffect(() => {
        removeAllCookies();
    }, []);

    const onSubmit = (data) => {
        if (localSelect == null)
            submitLogin(data);
        else
            submitLocal(data);
    }

    const submitLogin = (data) => {
        if (data.login == "" || data.senha == "") {
            showMessage("Aviso", "Informe o login e senha!", 'warning', null);
            return;
        }

        let json_submit = {
            username: data.login,
            password: data.senha
        }

        setshowLoading(true);
        usuario_api.authenticate(json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else if (result.data == null) {
                showMessage("Aviso", "Usuário/Senha não encontrado", 'warning', null);
            }
            else {
                setSessionCookie(result.data);
                signIn(result.data);
                if (result.data.localId != null)
                    history.push("/admin/home");
                else
                    loadLocais(result.data.usuarioId);
            }
        });
    }

    const submitLocal = (data) => {
        let session = getSessionCookie();
        session.localId = localSelect.localId;
        session.localDescricao = localSelect.identificacao;
        setSessionCookie(session);
        signIn(session);
        history.push("/admin/home");
    }

    const [localSelect, set_localSelect] = React.useState(null);
    const [locais, set_locais] = React.useState([]);
    const loadLocais = (usuarioId) => {
        local_api.getListAtivosByUsuarioId(usuarioId).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                if (result.data.length == 0) {
                    showMessage("Aviso", "Nenhum PEV cadastrado.", 'error', null);
                    return;
                }
                set_locais(result.data);
            }
        });
    }
    const handleLocal = (value) => {
        set_localSelect(value);
        setValue("local", value, true);
        clearErrors("local");
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content" style={{ marginTop: "50px" }}>
                <div>
                    <Card>
                        <CardBody>
                            <Container className="text-center">
                                <h3>BEM VINDO</h3>
                            </Container>
                            <Container style={{ marginTop: "30px" }}>
                                <Form onSubmit={handleSubmit(onSubmit)}>
                                    <Row>
                                        <Col lg="6" md="12">
                                            <div className="text-center">
                                                <img src={require("assets/img/logo.png")} className="mt-4" />
                                            </div>
                                        </Col>
                                        <Col lg="6" md="12">
                                            <Row>
                                                <Col md="12">
                                                    {locais.length == 0 &&
                                                        < Row >
                                                            <Col md="12" lg="12">
                                                                <FormGroup>
                                                                    <b><label>Login</label></b>
                                                                    <Input type="login" name="login" maxLength="200" innerRef={register()} />
                                                                </FormGroup>
                                                                <FormGroup>
                                                                    <b><label>Senha</label></b>
                                                                    <Input type="password" name="senha" maxLength="100" innerRef={register()} />
                                                                </FormGroup>
                                                                {/* <a style={{ cursor: "pointer" }} onClick={() => { history.push("/auth/esqueceusenha"); }}>Esqueci a senha</a> */}
                                                            </Col>
                                                        </Row>
                                                    }
                                                    {locais.length > 0 &&
                                                        < Row >
                                                            <Col md="12" lg="12">
                                                                <FormGroup>
                                                                    <label className="form-control-label">Selecione o Local:</label>
                                                                    <Select
                                                                        name="local"
                                                                        options={locais}
                                                                        getOptionLabel={p => p.identificacao}
                                                                        getOptionValue={p => p.localId}
                                                                        value={localSelect != null && locais.find(obj => obj.localId === localSelect.localId)}
                                                                        onChange={(e) => { handleLocal(e) }}
                                                                        classNamePrefix="select"
                                                                        placeholder="[ Selecione ]"
                                                                        ref={e => register(
                                                                            { name: "local" },
                                                                            { required: true })
                                                                        }
                                                                    />
                                                                    {errors.local && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                    }
                                                </Col>
                                            </Row>
                                            <div className="text-right">
                                                <Button color="success" className="btn-mobile" type="submit">ENTRAR </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            </Container>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </>
    );
}